import { PAYMENT_METHODS, PAYMENT_METHOD_LABELS } from '../constants';

export const calculateTotalDue = (selectedPaymentMethod, paymentFees) => {
    switch (selectedPaymentMethod) {
        case PAYMENT_METHODS.ACH_DIRECT_DEBIT:
            return paymentFees.achTotal || 0;
        case PAYMENT_METHODS.ACH_BANK_TRANSFER:
            return paymentFees.achCreditTotal || 0;
        case PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD:
            return paymentFees.ccTotal || 0;
        case PAYMENT_METHODS.CHECK:
            return paymentFees.checkTotal || 0;
        default:
            return 0;
    }
};

export const calculateProcessingFee = (selectedPaymentMethod, paymentFees) => {
    switch (selectedPaymentMethod) {
        case PAYMENT_METHODS.ACH_DIRECT_DEBIT:
            return paymentFees.achFee || 0;
        case PAYMENT_METHODS.ACH_BANK_TRANSFER:
            return paymentFees.achCreditFee || 0;
        case PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD:
            return paymentFees.ccFee || 0;
        case PAYMENT_METHODS.CHECK:
            return paymentFees.checkFee || 0;
        default:
            return 0;
    }
};

export const getProcessingFeeLabel = (selectedPaymentMethod) => {
    switch (selectedPaymentMethod) {
        case PAYMENT_METHODS.ACH_DIRECT_DEBIT:
            return PAYMENT_METHOD_LABELS.ACH_DIRECT_DEBIT;
        case PAYMENT_METHODS.ACH_BANK_TRANSFER:
            return PAYMENT_METHOD_LABELS.ACH_BANK_TRANSFER;
        case PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD:
            return PAYMENT_METHOD_LABELS.CREDIT_OR_DEBIT__CARD;
        case PAYMENT_METHODS.CHECK:
            return PAYMENT_METHOD_LABELS.CHECK;
        default:
            return "Processor Fee";
    }
};